import { clsx, type ClassValue } from "clsx"
import { toast } from "sonner";
import { twMerge } from "tailwind-merge"
import { BLOCKS } from '@contentful/rich-text-types';
import slugify from 'slugify';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function uppercaseFirstLetter(str: string) {
  return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function formatDate(isoDateString: string, utcOffset: number = 0) {
  const date = new Date(isoDateString);

  // Adjust for UTC offset
  date.setMinutes(date.getMinutes() + utcOffset);

  // Convert to "Month Day, Year" format
  const formattedDate = date.toLocaleDateString("en-US", {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return formattedDate;
}

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Email copied to clipboard!')
  } catch (err) {
    console.error("Failed to copy!", err);
  }
};

// Helper to get plain text from a header node, handling marks like bold/italics
export function getPlainTextFromHeader(contentNode: any[]) {
  return contentNode.reduce((acc, current) => {
    return acc + current.value;
  }, '');
}

// Main function to extract and format H1, H2, H3 headers for the TOC
export function getHeadersFromRichText(richText: any) {
  if (!richText || !richText.content) {
    return [];
  }

  const isHeader = (content: any) => {
    return content.nodeType === BLOCKS.HEADING_1 || 
           content.nodeType === BLOCKS.HEADING_2 || 
           content.nodeType === BLOCKS.HEADING_3;
  };

  return richText.content
    .filter(isHeader)
    .map((heading: any) => {
      const plainText = getPlainTextFromHeader(heading.content);
      // Ensure slug is lowercase for consistency
      const slug = slugify(plainText, { lower: true, strict: true });
      
      // Determine heading level for indentation
      let level = 1;
      if (heading.nodeType === BLOCKS.HEADING_1) level = 1;
      else if (heading.nodeType === BLOCKS.HEADING_2) level = 2;
      else if (heading.nodeType === BLOCKS.HEADING_3) level = 3;
      
      return {
        text: plainText,
        href: `#${slug}`,
        level: level,
      };
    });
}